import { render } from "./adverseEventCrossTab.vue?vue&type=template&id=2e9fe70a&scoped=true"
import script from "./adverseEventCrossTab.js?vue&type=script&lang=js"
export * from "./adverseEventCrossTab.js?vue&type=script&lang=js"

import "./adverseEventCrossTab.vue?vue&type=style&index=0&id=2e9fe70a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9fe70a"]])

export default __exports__